// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","modal":"modal_modal__FQGY3","close":"modal_close__Nx8Z0"};